export const mapper = <T extends object>(param: {
  [key in keyof T]: T[key];
}): T => param;
